import CompanyDetailsClients from './CompanyDetailsClients';

export default CompanyDetailsClients;
